<div
  class="w-100 h-100"
  [ngClass]="{ overlay: isOpened }"
  (click)="
    isOpened = !isOpened; isOpened == false ? (showDropdownList = false) : true
  "
></div>
<nav
  class="navbar p-0 d-flex flex-nowrap"
  [style.marginRight.px]="navChatDockMargin || null"
>
  <!-- <div class="beta-vertical-text">Beta</div> -->
  <div class="container">
    <div class="mobile-menu w-100 gap-3">
      <div class="brand-logo cursor-pointer" [routerLink]="['/']">
        <img
          width="124"
          height="56"
          [src]="logoPath"
          alt="AIKosh"
          title="AIKosh"
        />
      </div>
      <div class="d-flex align-items-center justify-content-end gap-3">
        <div
          class="search-input search-input-container position-relative"
          (click)="isShowGlobalSearch = true"
        >
          <div class="position-absolute search-input__search-icon">
            <img src="images/search.svg" height="24" width="24" alt="search" />
          </div>
          <input readonly type="text" placeholder="Search" />
        </div>

        <div
          class="toggle-menu align-items-center justify-content-center"
          (click)="
            isOpened = !isOpened;
            isOpened == false ? (showDropdownList = false) : true
          "
        >
          <img
            fetchPriority="high"
            src="images/toggle-menu.svg"
            alt="AIKosh"
            title="AIKosh"
            height="32"
            width="32"
          />
        </div>
      </div>
    </div>
    <div
      class="web-menu navbar-section d-flex align-items-center justify-content-between"
      [ngClass]="{ opened: isOpened }"
    >
      <div class="navbar-section__left d-flex align-items-center">
        <div class="brand-logo cursor-pointer" [routerLink]="['/']">
          <img
            width="96"
            height="44"
            fetchpriority="high"
            [src]="logoPath"
            alt="AIKosh"
            title="AIKosh"
            style="z-index: 1; background-color: none !important"
          />
        </div>
        <ul
          class="navbar-section__menu d-flex justify-content-start p-0 m-0 w-100 w-md-auto"
        >
          <!--Datasets-->
          <li
            routerLinkActive="active-category"
            (click)="isOpened = false; showDropdownList = false"
          >
            <a
              class="text-decoration-none"
              routerLinkActive="active-link"
              [routerLink]="['/', routes.home, routes.datasets]"
            >
              Datasets</a
            >
          </li>
          <!-- <li
            class="has-child position-relative"
            routerLinkActive="active-category"
            (click)="onDropdownClickForDataset()"
          >
            <span class="dropdown-icon"
              >Datasets
              <svg
                width="6"
                height="4"
                viewBox="0 0 6 4"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.807026 1.80675L2.53369 3.53341C2.79369 3.79341 3.21369 3.79341 3.47369 3.53341L5.20036 1.80675C5.62036 1.38675 5.32036 0.666748 4.72703 0.666748H1.27369C0.68036 0.666748 0.387027 1.38675 0.807026 1.80675Z"
                  fill="#212121"
                />
              </svg>
            </span>
            <ul
              class="position-absolute navbar-section__dropdown p-0 m-0 overflow-hidden"
              [ngClass]="showDropdownListForDataset ? 'd-block' : ''"
            >
              <li
                (click)="isOpened = false; showDropdownList = false"
                class="p-0"
              >
                <a
                  class="text-decoration-none py-2 px-3 w-100"
                  routerLinkActive="active-link"
                  [routerLink]="['/', routes.home, routes.datasets]"
                >
                  Dataset Repository
                </a>
              </li>
              <li
                (click)="isOpened = false; showDropdownList = false"
                class="p-0"
              >
                <a
                  class="text-decoration-none d-block py-2 px-3 w-100"
                  routerLinkActive="active-link"
                  [routerLink]="['/', routes.home, routes.catalogue]"
                >
                  Dataset catalogue
                </a>
              </li>
            </ul>
          </li> -->

          <!--Models-->
          <li
            routerLinkActive="active-category"
            (click)="isOpened = false; showDropdownList = false"
          >
            <a
              class="text-decoration-none"
              routerLinkActive="active-link"
              [routerLink]="['/', routes.home, routes.models]"
            >
              Models</a
            >
          </li>
          <!--Model Tryout-->
          <li
            routerLinkActive="active-category"
            (click)="isOpened = false; showDropdownList = false"
          >
            <a
              class="text-decoration-none"
              routerLinkActive="active-link"
              [routerLink]="['/', routes.home, routes.modelTryout]"
            >
              Model Tryout
            </a>
          </li>

          <!--Use cases-->
          <!-- <li
            routerLinkActive="active-category"
            (click)="isOpened = false; showDropdownList = false"
          >
            <a
              class="text-decoration-none"
              routerLinkActive="active-link"
              [routerLink]="['/', routes.home, routes.usecases]"
            >
              Use Cases
            </a>
          </li> -->

          <!--Use cases-->
          <li
            routerLinkActive="active-category"
            (click)="isOpened = false; showDropdownList = false"
          >
            <a
              class="text-decoration-none"
              routerLinkActive="active-link"
              [routerLink]="['/', routes.home, routes.notebook]"
            >
              Notebook
            </a>
          </li>

          <!--Others-->
          <li
            class="has-child position-relative"
            routerLinkActive="active-category"
            (click)="onDropdownClick()"
          >
            <span class="dropdown-icon text-nowrap"
              >Other
              <svg
                width="12"
                height="8"
                viewBox="0 0 6 4"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.807026 1.80675L2.53369 3.53341C2.79369 3.79341 3.21369 3.79341 3.47369 3.53341L5.20036 1.80675C5.62036 1.38675 5.32036 0.666748 4.72703 0.666748H1.27369C0.68036 0.666748 0.387027 1.38675 0.807026 1.80675Z"
                  fill="#212121"
                />
              </svg>
            </span>
            <ul
              class="position-absolute navbar-section__dropdown p-0 m-0 overflow-hidden"
              [ngClass]="showDropdownList ? 'd-block' : ''"
            >
              <!-- [ngStyle]="showDropdown()" -->

              <li
                (click)="isOpened = false; showDropdownList = false"
                class="p-2"
              >
                <a
                  class="text-decoration-none ps-2"
                  routerLinkActive="active-link"
                  [routerLink]="['/', routes.home, routes.usecases]"
                >
                  Use Cases
                </a>
              </li>
              <li
                (click)="isOpened = false; showDropdownList = false"
                class="p-0"
              >
                <a
                  class="text-decoration-none py-2 px-3 w-100"
                  routerLinkActive="active-link"
                  [routerLink]="['/', routes.home, routes.toolkit]"
                >
                  Toolkits
                </a>
              </li>
              <li
                (click)="isOpened = false; showDropdownList = false"
                class="p-0"
              >
                <a
                  class="text-decoration-none py-2 px-3 w-100"
                  routerLinkActive="active-link"
                  [routerLink]="['/', routes.home, routes.competitions]"
                >
                  Competitions
                </a>
              </li>
              <li
                (click)="isOpened = false; showDropdownList = false"
                class="p-2"
              >
                <a
                  class="text-decoration-none ps-2"
                  routerLinkActive="active-link"
                  [routerLink]="['/', routes.home, routes.rankings]"
                >
                  Leaderboard
                </a>
              </li>

              <li
                (click)="isOpened = false; showDropdownList = false"
                class="p-2"
              >
                <a
                  class="text-decoration-none ps-2"
                  routerLinkActive="active-link"
                  [routerLink]="[
                    '/',
                    routes.home,
                    routes.article,
                    routes.categoryListing,
                  ]"
                >
                  Articles
                </a>
              </li>
              <li
                (click)="isOpened = false; showDropdownList = false"
                class="p-2"
              >
                <a
                  class="text-decoration-none ps-2"
                  routerLinkActive="active-link"
                  [routerLink]="['/', routes.home, routes.organization]"
                >
                  Organizations
                </a>
              </li>

              <li
                (click)="isOpened = false; showDropdownList = false"
                class="p-2"
              >
                <a
                  class="text-decoration-none ps-2"
                  routerLinkActive="active-link"
                  [routerLink]="[
                    '/',
                    routes.home,
                    routes.publicProfile,
                    routes.org,
                    communityId,
                  ]"
                >
                  Community
                </a>
              </li>
              <li
                (click)="isOpened = false; showDropdownList = false"
                class="p-2"
              >
                <a
                  class="text-decoration-none ps-2 d-block"
                  routerLinkActive="active-link"
                  [routerLink]="['/', routes.home, routes.resources]"
                >
                  Tutorials
                </a>
              </li>

              <li
                (click)="isOpened = false; showDropdownList = false"
                class="p-2"
              >
                <a
                  class="text-decoration-none ps-2 d-block"
                  routerLinkActive="active-link"
                  [routerLink]="['/', routes.home, routes.userManual]"
                >
                  User Manual
                </a>
              </li>
            </ul>
          </li>
          <!--Workshop-->
          <!--Workshop-->
          <li
            *ngIf="showWorkshop"
            routerLinkActive="active-category"
            (click)="isOpened = false; showDropdownList = false"
          >
            <a
              style="
                background-color: var(--primary);
                color: var(--white);
                padding: 8px 20px;
                border-radius: 6px;
                font-weight: 600;
                font-size: 14px;
                text-decoration: none;
                display: inline-block;
              "
              routerLinkActive="active-link"
              [routerLink]="['/', routes.workshop]"
            >
              University Engagement
            </a>
          </li>
        </ul>
      </div>
      <span class="mx-2"></span>
      <div class="navbar-section__right d-flex align-items-center">
        <div
          class="search-input search-input-container position-relative"
          (click)="isShowGlobalSearch = true"
        >
          <div class="position-absolute search-input__search-icon">
            <img src="images/search.svg" height="24" width="24" alt="search" />
          </div>
          <input type="text" readonly placeholder="Search" />
        </div>

        <ng-container *ngIf="isAuthResolved; else _authLoading">
          <ng-container *ngIf="!utilService.isUserLoggedIn(); else loggedIn">
            <a
              [routerLink]="['/', routes.account, routes.user, routes.login]"
              (click)="onMeriPehchanLogin()"
              role="button"
              title="Login"
              class="login-register-btn btn btn-bordered-black login"
              >Login</a
            >
            <a
              [routerLink]="[
                '/',
                routes.account,
                routes.register,
                routes.step1,
              ]"
              role="button"
              title="Register"
              class="login-register-btn btn btn-secondary register"
              >Register</a
            >
          </ng-container>
        </ng-container>
        <ng-template #_authLoading></ng-template>

        <ng-template #loggedIn>
          <a
            (click)="redirectToDashboard()"
            role="button"
            title="Dashboard"
            class="login-register-btn btn btn-bordered-black login"
            >Dashboard</a
          >
          @if (renderNavbarContent) {
            <div data-bs-toggle="dropdown" class="cursor-pointer">
              <button
                [title]="userProfile?.fullName"
                class="profile-dropdown-toggle button-no-style dropdown-toggle"
              >
                <div
                  [ngClass]="
                    userProfile?.fullName && !userProfile?.profile_image
                      ? 'd-flex bhashini-skip-translation'
                      : 'd-none bhashini-skip-translation'
                  "
                  #imgPlaceholder
                  id="img-placeholder"
                ></div>
                @if (userProfile?.profile_image || !userProfile?.fullName) {
                  <ng-container
                    *ngTemplateOutlet="
                      profileImage;
                      context: {
                        fullName: userProfile?.fullName,
                        imageURL: userProfile?.profile_image,
                      }
                    "
                  ></ng-container>
                }
              </button>
            </div>

            <ul class="profile-dropdown-menu dropdown-menu text-sm p-0">
              <li>
                <a
                  class="d-flex p-3 cursor-pointer text-decoration-none text-black"
                  (click)="utilService.onProfileClick(userProfile?.id, 'user')"
                >
                  <div
                    [ngClass]="
                      userProfile?.fullName && !userProfile?.profile_image
                        ? 'd-flex bhashini-skip-translation'
                        : 'd-none bhashini-skip-translation'
                    "
                    #dropImgPlaceholder
                    id="drop-img-placeholder"
                  ></div>
                  @if (userProfile?.profile_image || !userProfile?.fullName) {
                    <ng-container
                      *ngTemplateOutlet="
                        profileImage;
                        context: {
                          fullName: userProfile?.fullName,
                          imageURL: userProfile?.profile_image,
                        }
                      "
                    ></ng-container>
                  }
                  <div class="ms-3">
                    <h4 class="text-sm fw-600 mb-0">
                      {{ userProfile?.fullName || "N.A." }}
                    </h4>
                    <h5
                      class="text-xs text-gray-dark fw-500 text-capitalize mb-0"
                    >
                      {{ userProfile?.roles | formatRoles }}
                    </h5>
                  </div>
                </a>
              </li>

              @if (isContributor || isOrgAdmin) {
                <li>
                  <a
                    class="d-flex p-3 cursor-pointer text-decoration-none text-black"
                    (click)="
                      utilService.onProfileClick(
                        userProfile?.orgDetails?.id,
                        'org'
                      )
                    "
                  >
                    <ng-container
                      *ngTemplateOutlet="
                        profileImage;
                        context: {
                          fullName: userProfile?.orgDetails?.name,
                          imageURL: userProfile?.orgDetails?.logo,
                        }
                      "
                    ></ng-container>
                    @if (renderNavbarContent) {
                      <div class="ms-3">
                        <h4 class="text-sm fw-600 mb-0">
                          {{ userProfile?.orgDetails?.name }}
                        </h4>
                        <h5
                          class="text-xs text-gray-dark fw-500 text-capitalize mb-0"
                        >
                          {{ getGroupLable }}
                        </h5>
                      </div>
                    }
                  </a>
                </li>
              }

              <li>
                <a
                  class="text-black fw-500 d-flex align-items-center text-decoration-none px-3"
                  (click)="onProfileOptionsClicked('editUserProfile')"
                >
                  <span
                    class="dropdown-menu-icon me-2"
                    [innerHTML]="profileBlackSVG | safeHTML"
                  ></span>
                  My Profile
                </a>
              </li>

              @if (isOrgAdmin) {
                <li>
                  <a
                    class="text-black fw-500 d-flex align-items-center text-decoration-none px-3"
                    (click)="onProfileOptionsClicked('editOrg')"
                  >
                    <span
                      class="dropdown-menu-icon me-2"
                      [innerHTML]="organizationBlackSVG | safeHTML"
                    ></span>
                    Organization Profile
                  </a>
                </li>
              }

              <li>
                <a
                  class="text-black fw-500 d-flex align-items-center text-decoration-none px-3"
                  (click)="onProfileOptionsClicked('accountSettings')"
                >
                  <span
                    class="dropdown-menu-icon me-2"
                    [innerHTML]="accountSettingSVG | safeHTML"
                  ></span>
                  Account Settings
                </a>
              </li>

              <li class="dropstart">
                <button
                  data-bs-toggle="dropdown"
                  class="help-center-btn button-no-style fw-500 d-flex align-items-center dropdown-toggle w-100 px-3"
                  (click)="$event.stopPropagation()"
                >
                  <span
                    class="dropdown-menu-icon me-2"
                    [innerHTML]="helpBlackSVG | safeHTML"
                  ></span>
                  Help Center
                  <span
                    class="dropleft-menu-icon ms-auto"
                    [innerHTML]="arrowRightBlackSVG | safeHTML"
                  >
                  </span>
                </button>

                <ul class="dropdown-menu text-sm p-0">
                  <li>
                    <a
                      class="text-black fw-500 d-block text-decoration-none px-3"
                      (click)="onProfileOptionsClicked('faq')"
                      >FAQs</a
                    >
                  </li>
                  <li>
                    <a
                      class="text-black fw-500 d-block text-decoration-none px-3"
                      (click)="onProfileOptionsClicked('userManual')"
                      >User Manual</a
                    >
                  </li>
                  <li>
                    <a
                      class="text-black fw-500 d-block text-decoration-none px-3 cursor-pointer"
                      (click)="onProfileOptionsClicked('grievanceReport')"
                      >Grievances</a
                    >
                  </li>
                </ul>
              </li>

              <li
                role="button"
                class="text-btn-color-cancel d-flex align-items-center fw-500 px-3"
                (click)="logoutExistingUser()"
              >
                <span
                  class="dropdown-menu-icon me-2"
                  [innerHTML]="logoutDangerSVG | safeHTML"
                ></span
                >Logout
              </li>
            </ul>
          }
          <!-- <a
            (click)="logoutExistingUser()"
            role="button"
            title="Logout"
            class="login-register-btn btn btn-danger register"
            >Logout</a
          > -->
        </ng-template>
        <!-- <div class="vertical-line"></div> -->
        <!-- <a
        (click)="onParicahayLogin()"
        role="button"
        title="Login"
        class="login-register-btn btn btn-bordered-black parichay d-flex justify-content-center align-items-center"
        ><img class="meri-pehchaan-logo position-absolute" fetchpriority="high" width="51" height="21"
        src="images/parichay.png" alt="Parichay" /></a
      > -->
      </div>
    </div>
  </div>
</nav>

<ng-template
  let-width="width"
  let-height="height"
  let-fullName="fullName"
  let-imageURL="imageURL"
  #profileImage
>
  <img
    imagePlaceholder
    [imageFallBack]="'images/fallback-avatar.png'"
    class="profile-image rounded-circle bg-white object-fit-contain"
    [ngStyle]="{
      'max-width': (width || 40) + 'px',
      'max-height': (height || 40) + 'px',
    }"
    [width]="width || 40"
    [height]="height || 40"
    [src]="imageURL"
    [alt]="fullName"
    class="object-fit-contain"
  />
</ng-template>

@if (isShowGlobalSearch) {
  <app-global-search (onClose)="isShowGlobalSearch = false"></app-global-search>
}
